import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";
import { toast } from "react-toastify";

// FETCH PAST UPLOADS
export const fetchPastUploads = createAsyncThunk(
  "pastUploads/fetchPastUploads",

  async (
    { pageNumber = 1, pageSize = 10, search = "" },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.post(
        "/auth/pastuploaddetails",
        {
          pageNumber,
          pageSize,
          search,
        }
      );

      return response.data.items;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Failed to fetch past uploads";

      toast.error(message);

      return rejectWithValue(message);
    }
  }
);

const pastUploadsSlice = createSlice({
  name: "pastUploads",

  initialState: {
    pastUploads: [],
    pagination: null,

    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // FETCH PAST UPLOADS
      .addCase(fetchPastUploads.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchPastUploads.fulfilled, (state, action) => {
        state.loading = false;

        state.pastUploads =
          action.payload?.Data || [];

        state.pagination =
          action.payload?.pagination || null;
      })

      .addCase(fetchPastUploads.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default pastUploadsSlice.reducer;